/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Reference_Record_In_UseInputs */

const en_error_reference_record_in_use = /** @type {(inputs: Error_Reference_Record_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other data still uses this record: it cannot be deleted.`)
};

/**
* | output |
* | --- |
* | "Other data still uses this record: it cannot be deleted." |
*
* @param {Error_Reference_Record_In_UseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_reference_record_in_use = /** @type {((inputs?: Error_Reference_Record_In_UseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Reference_Record_In_UseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_reference_record_in_use(inputs)
});